// 设置点击语言时的状态
export const SET_LANG_ACTIVE = (state, step) => {
    state.isShowdown = step;
};
// 设置语言
export const SET_LANG_LIST = (state, data) => {
    state.langlist = data;
};
// 切换语言
export const SET_LOCAL_LANG = (state, data) => {
    state.localLang = data;
};
// 首登录状态-->控制首页弹窗
export const SET_NEW_LOGIN = (state, data) => {
    state.newLogin = data;
};
// Loading
export const SET_LOADING = (state, data) => {
    state.loadingType = data;
};
